import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=f42c1daa&scoped=true&"
import script from "./optional.vue?vue&type=script&lang=js&"
export * from "./optional.vue?vue&type=script&lang=js&"
import style0 from "./optional.vue?vue&type=style&index=0&id=f42c1daa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c1daa",
  null
  
)

export default component.exports